import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import Headshot from "../components/Headshot";
import YoutubeEmbed from "../components/YoutubeEmbed";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Our Clients - Elm Street</title>
        <meta
          name="description"
          content="Nothing feels better than happy clients celebrating their productivity, success &amp; growth using Elm Street. Are you going to be the next success story?"
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/ourclients" />
        <meta property="og:title" content="Our Clients - Elm Street" />
        <meta
          property="og:description"
          content="Nothing feels better than happy clients celebrating their productivity, success &amp; growth using Elm Street. Are you going to be the next success story?"
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('clientsbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street We Love Our Clients"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>the power</span>
                    <br />
                    of success
                  </Typography>
                  <p>Hear what customers have to say about the power of Elm Street solutions.</p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container
        maxWidth="lg"
        style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "90px", paddingBottom: "70px" }}
      >
        <Grid container columnSpacing={8} style={{ paddingBottom: "36px" }}>
          <Grid sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h4" component="h4">
              IDX Broker
            </Typography>
            <br />
            “Of all the different IDX providers out there, IDX Broker leads the pack on multiple levels. Not only does
            IDX Broker focus on valuable SEO features necessary to compete in today’s search-driven world, it also
            provides valuable information for more in-depth tracking and analytics. No other IDX product we’ve seen
            offers such a variety of invaluable tools and information critical to our business."
            <br />
            <br />- Jeff H.
          </Grid>
        </Grid>
      </Container>

      <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "90px", paddingBottom: "70px" }}
        >
          <Grid container columnSpacing={8} style={{ paddingBottom: "36px" }}>
            <Grid sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h4" component="h4">
                IXACT Contact
              </Typography>
              <br />
              “Referral marketing is the base of any strong real estate practice. IXACT Contact has helped us increase
              our business by over 100% in the 2 years we’ve been using it.”
              <br />
              <br />- Keith R.
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container
        maxWidth="lg"
        style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "90px", paddingBottom: "70px" }}
      >
        <Grid container columnSpacing={8} style={{ paddingBottom: "36px" }}>
          <Grid sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h4" component="h4">
              Morris Marketing Group
            </Typography>
            <br />
            “I have been using the Client Referrals System for over 20 years and have achieved a 95% referral-based
            business. It’s a phenomenal marketing system that’s not only customizable and flexible but also runs itself
            if you get too busy. Using this System is one of the best things I have ever done in real estate.”
            <br />
            <br />- Paul R.
          </Grid>
        </Grid>
      </Container>

      <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "90px", paddingBottom: "70px" }}
        >
          <Grid container columnSpacing={8} style={{ paddingBottom: "36px" }}>
            <Grid sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h4" component="h4">
                OutboundEngine
              </Typography>
              <br />
              “It’s so easy. My clients get great, relevant information from me on a regular basis and I don’t even have
              to think about it. The content is great and looks so professional.”
              <br />
              <br />- Jenny S.
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container
        maxWidth="lg"
        style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "90px", paddingBottom: "70px" }}
      >
        <Grid container columnSpacing={8} style={{ paddingBottom: "36px" }}>
          <Grid sm={12} style={{ paddingBottom: "24px" }}>
            <Typography variant="h4" component="h4">
              Aiva
            </Typography>
            <br />
            “Aiva has been a great addition to our lead conversion strategy. Our contact rate for new leads doubled
            (from 25% to almost 50%). After trying several other companies, I can tell you that Aiva is the best,
            hands-down.”
            <br />
            <br />- Bob H.
          </Grid>
        </Grid>
      </Container>

      <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "90px", paddingBottom: "70px" }}
        >
          <Grid container columnSpacing={8} style={{ paddingBottom: "36px" }}>
            <Grid sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h4" component="h4">
                VoicePad
              </Typography>
              <br />
              “Last year, our company received over 16,000 phone and text leads from VoicePad’s On-Demand Reception and
              we’ve been able to track ALL of them. It’s absolutely phenomenal!”
              <br />
              <br />- Howard L.
            </Grid>
          </Grid>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
